import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { useWindowStore, useAppStore } from '../../../stores';
import { FloorPlanPropTypes, FloorPlanDefaultProps } from '../../../utils/DrupalEntityTypes/FloorPlan/FloorPlanPropTypes';
import { sanitizeStingALaDrupal } from '../../../utils/common';

import { ReactComponent as DownloadIcon } from '../../../SVGAssets/DownloadIcon.svg';

import './FloorPlanImagesWidgetButtons.scss';

const FloorPlanImagesWidgetButtons = ( {
  activeFloorPlan,
  setActiveFloorPlan,
  data,
  contentType,
} ) => {
  const [ showDownload, setShowDownload ] = useState( false );
  const [ sanitizedTitle, setSanitizedTitle ] = useState('none');

  const isMobile = useWindowStore((state) => state.isMobile);
  const settings = useAppStore((state) => state.settings);
  const {
    platform,
    urlSlug,
  } = settings || {};

  const {
    drupalNid,
    title,
    twoD,
    threeD,
    downloadablePdf,
  } = data;

  const threeDSrc = threeD?.modal;
  const twoDSrc = twoD?.modal;

  useEffect( () => {
    if ( platform === 'page' ) {
      setShowDownload( true );
    }
  }, [ platform ] );

  // Sanitize fp title for url.
  useEffect(() => {
    if ( title ) {
      const rawSanitizedTitle = sanitizeStingALaDrupal( title );
      setSanitizedTitle( rawSanitizedTitle );
    }
  }, [ title ])

  const handleFpToggle = () => {
    setActiveFloorPlan( !activeFloorPlan );
  };

  const handleDownload = () => {
    const link = document.createElement( 'a' );
    link.href = downloadablePdf;
    link.target = '_blank';
    document.body.appendChild( link );
    link.click();
    document.body.removeChild( link );
    // @TODO: Add Fathom event.
  };

  const showToggle = !isMobile && twoDSrc && threeDSrc;
  const hasButtons = showToggle || showDownload;

  return (
    <div className={classnames('floorPlanImagesWidget__buttons', {
      'floorPlanImagesWidget__buttons--hasButtons': hasButtons,
    })}>

      { showToggle && (
        <button
          type="button"
          className={
            classnames( 'floorPlanImagesWidget__button', {
              'floorPlanImagesWidget__button--active': !activeFloorPlan,
            } )
          }
          onClick={handleFpToggle}
        >
          3D
        </button>
      )}

      { showToggle && (
        <button
          type="button"
          className={
            classnames( 'floorPlanImagesWidget__button', {
              'floorPlanImagesWidget__button--active': activeFloorPlan,
            } )
          }
          onClick={handleFpToggle}
        >
          2D
        </button>
      )}

      { showDownload && downloadablePdf && (
        <button
          type="button"
          onClick={handleDownload}
          className="floorPlanImagesWidget__button floorPlanImagesWidget__button--download"
        >
          <DownloadIcon />
          <span>Download Floor Plan</span>
        </button>
      )}

      { showDownload && contentType === 'floor_plan' && (
        <Link
          className="floorPlanImagesWidget__button"
          target="_blank"
          to={ `/${urlSlug}/floor-plan/${sanitizedTitle}/${drupalNid}?mode=print` }
        >
          Print
        </Link>
      )}

    </div>
  );
};

FloorPlanImagesWidgetButtons.propTypes = {
  activeFloorPlan: PropTypes.bool.isRequired,
  setActiveFloorPlan: PropTypes.func.isRequired,
  data: FloorPlanPropTypes.data,
  contentType: PropTypes.string,
};

FloorPlanImagesWidgetButtons.defaultProps = {
  data: FloorPlanDefaultProps.data,
  contentType: '',
};

export default FloorPlanImagesWidgetButtons;
